import { compile } from 'handlebars';
export const oauthPageStyles = `
    body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Open Sans', 'Helvetica Neue', sans-serif;
        background-color: #f8fafc;
        margin: 0;
        padding: 20px;
        box-sizing: border-box;
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        line-height: 1.4;
    }
    .container {
        background: white;
        border-radius: 8px;
        border: 1px solid #e9ecef;
        box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05);
        padding: 24px;
        margin: 0;
        box-sizing: border-box;
        max-width: 450px;
        width: 100%;
        text-align: center;
    }
    .logo {
        width: 130px;
        height: auto;
        margin: 0 auto 24px auto;
        display: block;
    }
    h1 {
        color: #111418;
        margin: 0 0 16px 0;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
    }
    p {
        color: #6c757d;
        margin: 0 0 12px 0;
        line-height: 1.4;
        font-size: 14px;
    }
    .icon {
        width: 32px;
        height: 32px;
        margin: 0 auto 16px auto;
        display: block;
    }
    .success .icon {
        color: #111418;
    }
    .error .icon {
        color: #6c757d;
    }
    .stack {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    .oauth-btn,
    .button {
        display: inline-block;
        padding: 8px 24px;
        border: 1px solid #e9ecef;
        border-radius: 8px;
        font-weight: 500;
        font-size: 14px;
        cursor: pointer;
        text-decoration: none;
        transition: background 0.15s, border-color 0.15s;
    }
    .oauth-btn.approve,
    .button {
        background: #111418;
        color: #fff;
        border-color: #111418;
    }
    .oauth-btn.approve:hover,
    .button:hover {
        background: #2c2e33;
        border-color: #2c2e33;
    }
    .oauth-btn.deny {
        background: transparent;
        color: #111418;
        border-color: #e9ecef;
    }
    .oauth-btn.deny:hover {
        background: #f8fafc;
        border-color: #dee2e6;
    }
`;
// Lightdash logo SVG
const LIGHTDASH_LOGO_SVG = `
<svg class="logo" viewBox="0 0 433 91" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M77.6432 54.6553H105.741V66.4099H64.2842V2.23145H77.6432V54.6553Z" fill="black"/>
    <path d="M116.068 0C118.194 0 119.975 0.743596 121.411 2.23081C122.905 3.6608 123.652 5.43401 123.652 7.5504C123.652 9.6096 122.905 11.3828 121.411 12.87C119.975 14.3 118.194 15.015 116.068 15.015C113.942 15.015 112.16 14.3 110.724 12.87C109.288 11.3828 108.569 9.6096 108.569 7.5504C108.569 5.49121 109.316 3.718 110.81 2.23081C112.304 0.743596 114.057 0 116.068 0ZM122.359 66.4092H109.776V22.0505H122.359V66.4092Z" fill="black"/>
    <path d="M148.734 21.1934C154.825 21.1934 159.249 23.0238 162.007 26.6845V22.0513H173.815V68.0402C173.815 74.4466 171.775 79.5659 167.695 83.3983C163.615 87.2307 158.157 89.1469 151.32 89.1469C144.597 89.1469 139.311 87.6025 135.461 84.5138C131.611 81.4822 129.256 77.3351 128.394 72.0728L140.891 71.6438C141.178 73.8174 142.212 75.5048 143.994 76.706C145.775 77.9072 148.073 78.5078 150.889 78.5078C154.106 78.5078 156.635 77.6784 158.473 76.0196C160.369 74.418 161.317 72.0728 161.317 68.9839V62.6348C158.387 65.7807 154.192 67.3537 148.734 67.3537C142.414 67.3537 137.242 65.2374 133.22 61.0046C129.256 56.7717 127.273 51.1948 127.273 44.2736C127.273 37.3524 129.256 31.7754 133.22 27.5426C137.242 23.3099 142.414 21.1934 148.734 21.1934ZM150.803 31.9185C147.585 31.9185 144.971 33.0052 142.959 35.1788C141.006 37.3524 140.029 40.384 140.029 44.2736C140.029 48.1632 141.006 51.1948 142.959 53.3684C144.971 55.5419 147.585 56.6288 150.803 56.6288C153.963 56.6288 156.491 55.6278 158.387 53.6258C160.341 51.5666 161.317 48.7924 161.317 45.3031V43.244C161.317 39.7548 160.341 37.0092 158.387 35.0072C156.491 32.948 153.963 31.9185 150.803 31.9185Z" fill="black"/>
    <path d="M192.985 0V26.0832C195.399 22.9944 199.163 21.45 204.277 21.45C209.505 21.45 213.7 23.0516 216.86 26.2548C220.078 29.458 221.687 33.891 221.687 39.5537V66.6666H209.103V41.9561C209.103 39.1533 208.384 36.9797 206.949 35.4354C205.57 33.891 203.674 33.1187 201.26 33.1187C198.789 33.1187 196.778 33.9481 195.227 35.607C193.733 37.2086 192.985 39.3535 192.985 42.042V66.6666H180.403V0H192.985Z" fill="black"/>
    <path d="M243.768 33.1183L243.682 49.5919C243.682 51.88 244.315 53.5673 245.579 54.6542C246.843 55.7409 248.451 56.2844 250.404 56.2844C251.383 56.2844 252.675 56.1413 254.284 55.8554V67.0093C251.87 67.3525 249.543 67.5241 247.303 67.5241C242.246 67.5241 238.253 66.2944 235.322 63.8346C232.449 61.3179 231.041 57.5713 231.099 52.5949L231.186 33.1183H223.084V22.3075H231.272L231.357 7.63574H243.941L243.855 22.3075H254.284V33.1183H243.768Z" fill="black"/>
    <path d="M302.143 66.6666H290.335V62.1192C289.071 63.7208 287.29 65.0363 284.991 66.066C282.693 67.0956 280.05 67.6103 277.063 67.6103C270.743 67.6103 265.571 65.494 261.548 61.2612C257.584 57.0283 255.602 51.4514 255.602 44.5301C255.602 37.609 257.584 32.032 261.548 27.7992C265.571 23.5664 270.743 21.45 277.063 21.45C282.693 21.45 286.889 23.023 289.645 26.169V0H302.143V66.6666ZM279.131 32.175C275.913 32.175 273.299 33.2618 271.288 35.4354C269.334 37.609 268.358 40.6406 268.358 44.5301C268.358 48.4198 269.334 51.4514 271.288 53.625C273.299 55.7413 275.913 56.7995 279.131 56.7995C282.291 56.7995 284.82 55.7985 286.715 53.7965C288.669 51.7945 289.645 49.0204 289.645 45.474V43.5006C289.645 40.0114 288.669 37.2658 286.715 35.2638C284.82 33.2046 282.291 32.175 279.131 32.175Z" fill="black"/>
    <path d="M326.898 21.4502C332.931 21.4502 337.529 22.9661 340.688 25.9976C343.849 29.0292 345.429 33.4622 345.429 39.2966V66.6668H333.276V63.0632C330.346 66.0948 326.553 67.6105 321.899 67.6105C317.303 67.6105 313.683 66.4952 311.04 64.2644C308.398 61.9763 307.076 58.716 307.076 54.4832C307.076 46.0176 313.023 41.5273 324.916 41.0126L332.846 40.5835V38.8676C332.846 34.2916 330.92 32.0036 327.071 32.0036C325.06 32.0036 323.509 32.5755 322.417 33.7195C321.383 34.8636 320.865 36.2364 320.865 37.838L308.282 37.3231C308.282 33.2048 310.006 29.5439 313.454 26.3407C316.958 23.0804 321.44 21.4502 326.898 21.4502ZM332.846 48.8204L326.123 49.2494C321.814 49.421 319.659 50.9653 319.659 53.8826C319.659 56.5709 321.383 57.9152 324.831 57.9152C327.187 57.9152 329.111 57.286 330.604 56.0275C332.099 54.7691 332.846 52.9959 332.846 50.708V48.8204Z" fill="black"/>
    <path d="M367.548 21.4502C373.006 21.4502 377.259 22.7659 380.304 25.397C383.406 28.0282 385.159 31.4888 385.561 35.7787L373.064 36.4652C372.892 32.8616 370.995 31.0598 367.375 31.0598C363.985 31.0598 362.29 32.3181 362.29 34.835C362.29 35.1781 362.319 35.4928 362.377 35.7787C362.434 36.0648 362.55 36.3221 362.721 36.5509C362.951 36.7797 363.153 36.9799 363.324 37.1515C363.498 37.3231 363.785 37.4948 364.187 37.6664C364.59 37.838 364.906 37.9809 365.135 38.0954C365.422 38.2098 365.824 38.3527 366.341 38.5244C366.917 38.696 367.375 38.839 367.72 38.9533C368.065 39.0106 368.583 39.1249 369.272 39.2966C370.018 39.4682 370.594 39.6112 370.995 39.7255C376.109 41.0412 379.902 42.6428 382.371 44.5303C384.901 46.3607 386.164 49.1349 386.164 52.853C386.164 57.4289 384.556 61.0325 381.339 63.6638C378.12 66.295 373.639 67.6105 367.893 67.6105C362.205 67.6105 357.723 66.3807 354.448 63.9212C351.229 61.4043 349.391 57.8293 348.931 53.1961L361.515 52.5098C361.687 56.1705 363.842 58.0009 367.978 58.0009C369.702 58.0009 371.053 57.6578 372.029 56.9713C373.064 56.2277 373.582 55.2267 373.582 53.9683C373.582 52.6528 373.035 51.6804 371.944 51.0512C370.91 50.422 368.754 49.707 365.48 48.9062C363.182 48.3342 361.371 47.848 360.05 47.4476C358.786 47.0472 357.378 46.5038 355.827 45.8174C354.332 45.0738 353.213 44.273 352.466 43.415C351.718 42.5569 351.058 41.4702 350.483 40.1545C349.965 38.7817 349.707 37.2088 349.707 35.4356C349.707 31.1455 351.287 27.7421 354.448 25.2254C357.607 22.7085 361.974 21.4502 367.548 21.4502Z" fill="black"/>
    <path d="M403.303 0V26.0832C405.717 22.9944 409.48 21.45 414.595 21.45C419.823 21.45 424.018 23.0516 427.177 26.2548C430.396 29.458 432.005 33.891 432.005 39.5537V66.6666H419.42V41.9561C419.42 39.1533 418.702 36.9797 417.266 35.4354C415.887 33.891 413.992 33.1187 411.578 33.1187C409.107 33.1187 407.096 33.9481 405.545 35.607C404.05 37.2086 403.303 39.3535 403.303 42.042V66.6666H390.72V0H403.303Z" fill="black"/>
    <path d="M26.8892 22.6484H42.8932C45.5303 22.6484 47.1695 25.4575 45.8438 27.6794L20.7566 70.1648C20.1294 71.2268 18.989 71.8418 17.7917 71.8418C15.6109 71.8418 13.9574 69.8433 14.4705 67.719L21.0418 40.5368L26.8892 22.6484Z" fill="black"/>
    <path d="M32.3878 6.21237L26.7217 24.3172L20.8336 42.1711H3.79636C1.71516 42.1711 0.107613 40.3857 0.380322 38.3771L4.97332 4.90124C5.20297 3.2414 6.66699 2 8.38936 2H29.0578C31.3114 2 32.9619 4.09225 32.3878 6.21237Z" fill="black"/>
</svg>
`;
// OAuth response HTML template
const OAUTH_RESPONSE_TEMPLATE = `
<html>
    <head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <style>{{{styles}}}</style>
    </head>
    <body>
        <div class="stack">
            <div class="container {{status}}">
                {{{logo}}}
                <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {{{icon}}}
                </svg>
                <h1>{{title}}</h1>
                {{#each messages}}
                <p>{{this}}</p>
                {{/each}}
            </div>
        </div>
    </body>
</html>
`;
// OAuth redirect page template. This intentionally uses a meta refresh instead
// of an HTTP redirect: Chromium applies the authorize page's form-action CSP to
// HTTP redirects after the consent form POST, which blocks OAuth loopback URIs.
// Handlebars escapes redirectUrl in the refresh attribute context.
const OAUTH_REDIRECT_TEMPLATE = `
<html>
    <head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta http-equiv="refresh" content="0;url={{redirectUrl}}" />
        <title>Redirecting...</title>
        <style>{{{styles}}}</style>
    </head>
    <body>
        <div class="stack">
            <div class="container">
                {{{logo}}}
                <h1>Redirecting...</h1>
                <p>{{message}}</p>
                <a class="button" href="{{redirectUrl}}">Continue</a>
            </div>
        </div>
    </body>
</html>
`;
// OAuth authorization page template
const OAUTH_AUTHORIZE_TEMPLATE = `
<html>
    <head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Authorize Application</title>
        <style>
            {{{styles}}}
            .container { text-align: left; }
            .oauth-header {
                text-align: center;
                margin-bottom: 24px;
            }
            .oauth-message {
                text-align: center;
                margin-bottom: 16px;
                font-size: 14px;
                color: #111418;
            }
            .oauth-message strong {
                font-weight: 600;
            }
            .oauth-account {
                border: 1px solid #e9ecef;
                border-radius: 8px;
                overflow: hidden;
                margin-bottom: 20px;
            }
            .oauth-account-user {
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 12px 14px;
            }
            .oauth-avatar {
                flex-shrink: 0;
                width: 36px;
                height: 36px;
                border-radius: 50%;
                background: #111418;
                color: #f8fafc;
                font-size: 13px;
                font-weight: 600;
                letter-spacing: 0.02em;
                display: flex;
                align-items: center;
                justify-content: center;
                text-transform: uppercase;
            }
            .oauth-account-id {
                flex: 1;
                min-width: 0;
            }
            .oauth-account-name {
                font-weight: 600;
                color: #111418;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .oauth-account-email {
                font-size: 12px;
                color: #6c757d;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .oauth-switch-link {
                flex-shrink: 0;
                font-size: 12px;
                font-weight: 500;
                color: #6c757d;
                text-decoration: none;
            }
            .oauth-switch-link:hover {
                color: #111418;
                text-decoration: underline;
            }
            .oauth-account-org {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 8px 14px;
                border-top: 1px solid #e9ecef;
                background: #f8fafc;
            }
            .oauth-org-icon {
                flex-shrink: 0;
                width: 15px;
                height: 15px;
                color: #6c757d;
            }
            .oauth-account-org-name {
                flex: 1;
                min-width: 0;
                font-size: 13px;
                font-weight: 500;
                color: #111418;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .oauth-account-org-label {
                flex-shrink: 0;
                font-size: 11px;
                color: #6c757d;
            }
            .oauth-scopes {
                margin-bottom: 16px;
            }
            .oauth-scopes-title {
                font-size: 13px;
                font-weight: 600;
                color: #111418;
                margin: 0 0 4px 0;
            }
            .oauth-scope-item {
                display: flex;
                gap: 12px;
                padding: 12px 0;
                border-bottom: 1px solid #f8fafc;
            }
            .oauth-scope-item:last-child {
                border-bottom: none;
            }
            .oauth-scope-icon {
                flex-shrink: 0;
                width: 16px;
                height: 16px;
                margin-top: 2px;
            }
            .oauth-scope-content {
                flex: 1;
            }
            .oauth-scope-title {
                font-weight: 500;
                color: #111418;
                margin-bottom: 4px;
            }
            .oauth-scope-desc {
                font-size: 12px;
                color: #6c757d;
                line-height: 1.4;
            }
            .oauth-btn-row {
                /* row-reverse keeps Authorize as the first submit button (Enter approves) while showing Cancel on the left */
                display: flex;
                flex-direction: row-reverse;
                justify-content: center;
                gap: 12px;
                margin-top: 24px;
                padding-top: 16px;
                border-top: 1px solid #e9ecef;
            }
        </style>
    </head>
    <body>
        <div class="stack">
            <form class="container" method="POST" action="{{action}}">
                <div class="oauth-header">
                    {{{logo}}}
                    <h1>Authorize Application</h1>
                </div>

                <p class="oauth-message">
                    <strong>{{client_name}}</strong> wants to access your Lightdash account
                </p>

                <div class="oauth-account">
                    <div class="oauth-account-user">
                        <div class="oauth-avatar" aria-hidden="true">{{user.initials}}</div>
                        <div class="oauth-account-id">
                            <div class="oauth-account-name">{{user.firstName}} {{user.lastName}}</div>
                            {{#if user.email}}
                            <div class="oauth-account-email">{{user.email}}</div>
                            {{/if}}
                        </div>
                        <a class="oauth-switch-link" id="oauth-switch-account" href="{{loginUrl}}">Switch account</a>
                    </div>
                    {{#if user.organizationName}}
                    <div class="oauth-account-org">
                        <svg class="oauth-org-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <path d="M3 21h18" />
                            <path d="M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1" />
                            <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
                        </svg>
                        <span class="oauth-account-org-name">{{user.organizationName}}</span>
                        <span class="oauth-account-org-label">Organization</span>
                    </div>
                    {{/if}}
                </div>

                <div class="oauth-scopes">
                    <p class="oauth-scopes-title">{{client_name}} will be able to:</p>
                    {{#each scopes}}
                    <div class="oauth-scope-item">
                        <svg class="oauth-scope-icon" viewBox="0 0 16 16" fill="currentColor">
                            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0z"/>
                            <path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                        </svg>
                        <div class="oauth-scope-content">
                            <div class="oauth-scope-title">{{title}}</div>
                            <div class="oauth-scope-desc">{{description}}</div>
                        </div>
                    </div>
                    {{/each}}
                </div>

                {{#each hiddenInputs}}
                <input type="hidden" name="{{name}}" value="{{value}}" />
                {{/each}}

                <div class="oauth-btn-row">
                    <button type="submit" name="approve" value="true" class="oauth-btn approve">Authorize</button>
                    <button type="submit" name="approve" value="false" class="oauth-btn deny">Cancel</button>
                </div>
            </form>
        </div>
        <script>
            (function () {
                var switchLink = document.getElementById('oauth-switch-account');
                switchLink.addEventListener('click', function (event) {
                    event.preventDefault();
                    var loginUrl = switchLink.href;
                    // Log out first so the login page doesn't bounce straight back with the same session
                    fetch('/api/v1/logout', { credentials: 'same-origin' })
                        .catch(function () {
                            // Navigate anyway; the login page still lets the user switch accounts
                        })
                        .then(function () {
                            window.location.href = loginUrl;
                        });
                });
            })();
        </script>
    </body>
</html>
`;
// SVG icons for different response types
const OAUTH_ICONS = {
    success: '<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    error: '<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    sessionExpired: '<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 6v6l4 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
};
// Compile the templates once with proper type safety
const compiledResponseTemplate = compile(OAUTH_RESPONSE_TEMPLATE);
const compiledRedirectTemplate = compile(OAUTH_REDIRECT_TEMPLATE);
const compiledAuthorizeTemplate = compile(OAUTH_AUTHORIZE_TEMPLATE);
const UNSAFE_REDIRECT_PROTOCOLS = new Set(['javascript', 'data', 'vbscript', 'file', 'blob'].map((scheme) => `${scheme}:`));
export const isSafeRedirectScheme = (uri) => {
    try {
        const { protocol } = new URL(uri);
        return !UNSAFE_REDIRECT_PROTOCOLS.has(protocol.toLowerCase());
    }
    catch {
        return false;
    }
};
// Scope descriptions mapping
const SCOPE_DESCRIPTIONS = {
    read: {
        title: 'Read access',
        description: 'View your projects, dashboards, charts, and other resources',
    },
    write: {
        title: 'Write access',
        description: 'Create, update, and delete projects, dashboards, charts, and other resources',
    },
    'mcp:read': {
        title: 'MCP read access',
        description: 'Read access through Model Context Protocol',
    },
    'mcp:write': {
        title: 'MCP write access',
        description: 'Write access through Model Context Protocol',
    },
};
/**
 * Parses a scope string (e.g. "read write") and returns an array of scope objects with descriptions
 */
export const parseScopeString = (scopeString) => {
    if (!scopeString || typeof scopeString !== 'string') {
        return [];
    }
    const scopes = scopeString.trim().split(/\s+/);
    return scopes
        .map((scope) => SCOPE_DESCRIPTIONS[scope])
        .filter((scope) => scope !== undefined);
};
/**
 * Gets a friendly client name from the client_id
 */
export const getClientName = (clientId) => {
    const clientNames = {
        'lightdash-cli': 'Lightdash CLI tool',
    };
    return clientNames[clientId] || clientId;
};
/**
 * Generates an OAuth response HTML page using Handlebars templating
 * This prevents XSS issues by auto-escaping content while still allowing safe HTML in icons and styles
 */
export const generateOAuthResponseHtml = (status, title, messages, iconType = status === 'success' ? 'success' : 'error') => compiledResponseTemplate({
    styles: oauthPageStyles,
    logo: LIGHTDASH_LOGO_SVG,
    status,
    title,
    messages,
    icon: OAUTH_ICONS[iconType],
});
/**
 * Generates a success OAuth response
 */
export const generateOAuthSuccessResponse = (title = 'Authentication Successful!', messages = [
    'You have been successfully authenticated with Lightdash.',
    'You can close this window and return to the CLI.',
]) => generateOAuthResponseHtml('success', title, messages, 'success');
/**
 * Generates an error OAuth response
 */
export const generateOAuthErrorResponse = (title, messages, iconType = 'error') => generateOAuthResponseHtml('error', title, [...messages, 'You can close this window and try again.'], iconType);
/**
 * Generates a script-free redirect page for a previously validated OAuth URI.
 */
export const generateOAuthRedirectPage = (params) => {
    if (!isSafeRedirectScheme(params.redirectUrl)) {
        return generateOAuthErrorResponse('Unsupported redirect', [
            'This application uses an unsupported redirect and cannot continue.',
        ]);
    }
    return compiledRedirectTemplate({
        styles: oauthPageStyles,
        logo: LIGHTDASH_LOGO_SVG,
        ...params,
    });
};
const getUserInitials = (user) => {
    const initials = `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.trim();
    return initials || user.email?.charAt(0) || '?';
};
/**
 * Generates an OAuth authorization page HTML using Handlebars templating
 * This prevents XSS issues by auto-escaping all user content
 */
export const generateOAuthAuthorizePage = (params) => compiledAuthorizeTemplate({
    styles: oauthPageStyles,
    logo: LIGHTDASH_LOGO_SVG,
    ...params,
    user: {
        ...params.user,
        initials: getUserInitials(params.user),
    },
});
//# sourceMappingURL=oauth.js.map